import { render } from "./ReturnPolicy.vue?vue&type=template&id=58f83a59&scoped=true"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"

import "./ReturnPolicy.vue?vue&type=style&index=0&id=58f83a59&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f83a59"]])

export default __exports__